import { find } from "lodash";
import Utils, {
  hasItems,
  isBaseCoreElement,
  sortByRelevance,
} from "../../../helpers/utils";

const sortElements = (allElements, sortColumns = "name") => {
  const sortByColumns = sortColumns.split("|");

  allElements.sort((a, b) => {
    // For archive page
    if (sortByColumns.includes("is_active")) {
      if (a.is_active != b.is_active) {
        return (a.is_active || 0) > (b.is_active || 0) ? 1 : -1;
      }
    }

    if (sortByColumns.includes("is_predicted")) {
      if (a.was_predicted != b.was_predicted) {
        return a.was_predicted > b.was_predicted ? -1 : 1;
      }
      if (a.was_predicted) {
        if (a.probability == b.probability) {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        }
        return a.probability > b.probability ? -1 : 1;
      }
    }

    if (sortByColumns.includes("checked")) {
      if (a.is_selected != b.is_selected) {
        return (a.is_selected || 0) > (b.is_selected || 0) ? -1 : 1;
      }
    }

    if (sortByColumns.includes("is_favorite")) {
      if (a.is_favorite != b.is_favorite) {
        return (a.is_favorite || 0) > (b.is_favorite || 0) ? -1 : 1;
      }
    }

    if (sortByColumns.includes("is_core")) {
      if (a.is_core != b.is_core) {
        return (a.is_core || 0) > (b.is_core || 0) ? -1 : 1;
      }
    }

    if (sortByColumns.includes("is_major")) {
      if (a.is_major != b.is_major) {
        return (a.is_major || 0) > (b.is_major || 0) ? -1 : 1;
      }
    }

    return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
  });

  return allElements;
};

const filterResults = (controller, filters = {}, selectedSetIds = []) => {
  const {
    term = null,
    showFavorites = true,
    showArchived = false,
    showBaseSets = true,
    sortBy = "",
  } = filters;
  let filteredElements = controller.state.elements?.slice(0) || [];

  if (!showArchived) {
    filteredElements = filteredElements.filter((a) => a.is_active == 1);
  }

  if (showArchived && controller.state.archived_elements) {
    const archivedElements = controller.state.archived_elements || [];
    filteredElements = [...archivedElements, ...filteredElements];
  }

  if (!showFavorites) {
    filteredElements = filteredElements.filter((a) => a.is_favorite != 1);
  }

  // Multi terms search
  if (term) {
    const pattern = Utils.getSearchPattern(term);

    // Elements filter by name or by tags
    filteredElements = filteredElements.filter((a) => {
      return a.name && a.name.match(pattern);
    });
  }

  // Base Sets
  if (!showBaseSets) {
    filteredElements = filteredElements.filter(
      (s) => !isBaseCoreElement(s.name),
    );
  }

  // Preselect elements
  if (hasItems(selectedSetIds)) {
    filteredElements.forEach((element) => {
      element.is_selected = selectedSetIds.includes(element.id);
    });
  }

  return sortBy == "relevance" && term
    ? sortByRelevance(filteredElements, term)
    : sortBy == "nosort"
    ? filteredElements
    : sortElements(filteredElements, sortBy);
};

const findById = (controller, elementId) => {
  return find(controller.state.elements || [], (elem) => elem.id == elementId);
};

const ElementsHelper = {
  filterResults,
  sortElements,
  findById,
};

export default ElementsHelper;
